import {
  Box,
  VStack,
  HStack,
  Text,
  FormControl,
  FormHelperText,
  Breadcrumb,
  BreadcrumbItem,
  Badge,
  useDisclosure,
  useToast,
  CircularProgress,
  Checkbox,
} from "@chakra-ui/react";

import { useCallback, useEffect, useMemo, useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";

import { useHistory } from "react-router-dom";

import Select from "components/Select/Select";
import Input from "components/Input/Input";
import NumberInput from "components/Input/NumberInput";
import Button from "components/Button/Button";
import { RSelect, OptionLabel } from "components/Select/RSelect";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import BillPreview from "components/Modals/bills/BillPreview";
import SubmitPin from "components/Modals/SubmitPin";
import SuccessModal from "components/Modals/Success";

// import { ReactComponent as Mtn } from "assets/svg/mtn.svg";
// import { ReactComponent as Airtel } from "assets/svg/airtel.svg";
// import { ReactComponent as Glo } from "assets/svg/glo.svg";
// import { ReactComponent as NineMob } from "assets/svg/9mobile.svg";

// import { useGetCountriesQuery } from "services/arbitraryApi";

import {
  useGetSupportedCountriesQuery,
  useGetAirtimePlansQuery,
  useMakeBillV2Mutation,
} from "services/billsApi";

import { useGetWalletsQuery } from "services/walletApi";
import { useGetRateQuery } from "services/rateApi";

import capitalize from "lodash/capitalize";
import toUpper from "lodash/toUpper";
import toLower from "lodash/toLower";
import uniqBy from "lodash/uniqBy";

import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
// import currencyFormatter from "util/formatter";
import constants from "config/constant";

const Airtime = () => {
  const [state, setState] = useState({});
  const history = useHistory();
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isPinOpen,
    onOpen: onPinOpen,
    onClose: onPinClose,
  } = useDisclosure();

  const {
    isOpen: successOpen,
    onOpen: onSuccessOpen,
    onClose: onSuccessClose,
  } = useDisclosure();

  const supportedCoins = constants.stableCoins;

  const { data, isLoading: isCountriesLoading } =
    useGetSupportedCountriesQuery("airtime");

  const { data: wallets, isLoading: isWalletsLoading } = useGetWalletsQuery({
    pollingInterval: 10000,
  });

  // const { data: allCountries, isLoading: isCountriesDataLoading } =
  //   useGetCountriesQuery();

  const { data: plans, isFetching: isPlansLoading } = useGetAirtimePlansQuery(
    state?.country,
    {
      skip: !state?.country,
    }
  );

  const { data: rateData, isFetching: isUpdatingRate } =
    useGetRateQuery("usdngn");

  // const [
  //   makeBill,
  //   {
  //     data: billData,
  //     isLoading: isMakingBill,
  //     isSuccess: isBillSuccess,
  //     isError: isBillError,
  //     error: billError,
  //   },
  // ] = useMakeBillMutation();

  const [
    makeBill,
    {
      data: billData,
      isLoading: isMakingBill,
      isSuccess: isBillSuccess,
      isError: isBillError,
      error: billError,
    },
  ] = useMakeBillV2Mutation();

  // console.log("COUNTRIES", countriesData);

  // const handleSubmit = (pin) => {
  //   const airtimeNetwork = toLower(state?.operatorInfo?.name).split(" ");
  //   const phoneNumber = `+${state?.dialCode}${state?.phone?.replace(
  //     /^0+/,
  //     ""
  //   )}`;
  //   const reqData = {
  //     pin,
  //     billType: "airtime",
  //     country: toLower(state?.operatorInfo?.currency),
  //     coin: toLower(state?.coin),
  //     amount: +state.amount,
  //     phone: phoneNumber,
  //     operatorId: state?.operatorId,
  //     productId: state?.productId,
  //     airtimeNetwork: airtimeNetwork[airtimeNetwork.length - 1],
  //   };

  //   console.log("BUY DATA", reqData, airtimeNetwork, phoneNumber);
  //   makeBill(reqData);
  // };

  const handleSubmitV2 = (pin) => {
    // const airtimeNetwork = toLower(state?.operatorInfo?.name).split(" ");
    const phoneNumber = `+${state?.dialCode}${state?.phone?.replace(
      /^0+/,
      ""
    )}`;
    const reqData = {
      pin,
      billType: "airtime",
      country: toLower(state?.countryCode),
      coin: toLower(state?.coin),
      amount: state.amount,
      phone: phoneNumber,
      operatorId: state?.operatorId,
      productId: state?.productId,
      airtimeNetwork: toLower(state?.operatorInfo?.name),
      ported: state?.ported ?? false,
      ...state?.productInfo,
    };

    console.log("BUY DATA", reqData);
    makeBill(reqData);
  };

  const resetState = () => setState({});

  const handleState = (newState) => {
    setState({ ...state, ...newState });
  };

  const handleSuccessModalClose = () => {
    onSuccessClose();
    history.replace("/dashboard/bills");
    resetState();
  };

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    // console.log("ERROR VALUE", value);
    return value ?? "An unexpected error occurred";
  };

  // const supportedCountries = useMemo(() => {
  //   if (data && allCountries) {
  //     data?.countries?.forEach((supported) => {
  //       console.log("SUPPORTED COUNTRY", supported);
  //     });
  //   }
  // }, [data, allCountries]);

  const countries = useMemo(() => {
    if (data) {
      return data?.countries?.map((c) => ({
        label: <OptionLabel label={c.name} img={c.flag} />,
        value: c.id,
      }));
    }
  }, [data]);

  const getCountryCode = useCallback(
    (id) => {
      if (data && id) {
        const code = data?.countries?.find((c) => c.id === id)?.code;
        return toLower(code);
      }
    },
    [data]
  );

  const getCountryDialCode = useCallback(
    (id) => {
      if (data && id) {
        return data?.countries?.find((c) => c.id === id)?.dialCode;
      }
    },
    [data]
  );

  const product = useMemo(() => {
    if (state?.operatorInfo?.products) {
      const product = state?.operatorInfo?.products?.find(
        (p) =>
          p.priceType === "range" && toLower(p.productType).includes("top up")
      );
      return product;
    }
  }, [state?.operatorInfo?.products]);

  const topupTypes = useMemo(() => {
    if (state?.operatorInfo?.products)
      return uniqBy(state?.operatorInfo?.products, (p) => p.priceType)?.map(
        (p) => p.priceType
      );
  }, [state?.operatorInfo?.products]);

  const getProductPriceInfo = useCallback(
    (priceType) => {
      const product = uniqBy(
        state?.operatorInfo?.products,
        (p) => p.priceType
      ).find(
        (p) =>
          p.priceType === priceType && toLower(p.productType).includes("top up")
      );

      const map = {
        fixed: () => ({
          plan: product?.name,
          operatorPrice: product.operatorPrice,
          userPrice: product.userPrice,
        }),
        range: () => ({
          plan: product?.name,
          operatorMaxPrice: product.operatorMaxPrice,
          operatorMinPrice: product.operatorMinPrice,
          userMinPrice: product.userMinPrice,
          userMaxPrice: product.userMaxPrice,
        }),
        empty: () => ({}),
      };

      // console.log("PRODUCT PRICE INFO", map[product?.priceType ?? "empty"]());

      return map[product?.priceType ?? "empty"]();
    },
    [state?.operatorInfo]
  );

  // console.log("PRODUCT", product, topupTypes);

  const cryptoPrice = useMemo(() => {
    if (
      state?.operatorInfo &&
      state?.amount &&
      rateData?.exchangeRate?.sell &&
      state?.productId
    ) {
      const product = state?.operatorInfo?.products?.find(
        (p) => p.productId === state.productId
      );
      // return state.amount / rateData?.exchangeRate?.buy;

      const calcPrice = (currency, priceType) => {
        const map = {
          [`${currency}-fixed`]: state?.amount / rateData?.exchangeRate?.sell,
          [`${currency}-range`]:
            (Number(
              product?.userMaxPrice / product?.operatorMaxPrice
            ).toPrecision(2) *
              state.amount) /
            rateData?.exchangeRate?.sell,
          "ngn-range": state?.amount / rateData?.exchangeRate?.sell,
        };

        return map[`${currency}-${priceType}`];
      };

      // console.log("CRYPTO PRICE", product);

      return calcPrice(state?.operatorInfo?.currency, product?.priceType);
    }
  }, [state?.amount, rateData, state?.operatorInfo, state?.productId]);

  const operators = useMemo(() => {
    if (plans) {
      return plans?.plans?.map((p) => ({
        label: <OptionLabel label={p.name} img={p.brandLogo} />,
        value: p.operatorId,
      }));
    }
  }, [plans]);

  const getOperatorInfo = useCallback(
    (operatorId) => {
      const operator = plans?.plans.find((p) => p.operatorId === operatorId);
      return {
        logo: operator.brandLogo,
        name: operator.name,
        currency: operator.currency,
        flag: operator.countryFlag,
        products: operator.products,
      };
    },
    [plans]
  );

  const cryptocurrencies = useMemo(() => {
    if (wallets) {
      return wallets?.addresses?.filter((a) => a?.address && a?.coin);
    }
  }, [wallets]);

  const cryptoBalance = useMemo(() => {
    if (wallets) {
      return cryptocurrencies?.find((a) => a?.coin === state?.coin)?.balance
        ?.$numberDecimal;
    }
  }, [cryptocurrencies, state?.coin, wallets]);

  console.log("STATE", state);
  // console.log("PLANS", plans);

  useEffect(() => {
    if (isBillSuccess && billData) {
      onClose();
      onSuccessOpen();
    }

    if (isBillError && billError)
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(billError?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    // console.log("ERROR", billError);
  }, [
    isBillSuccess,
    billData,
    isBillError,
    billError,
    onClose,
    toast,
    onSuccessOpen,
  ]);

  const isDisabled = useMemo(
    () =>
      !(
        state?.country &&
        state?.operatorId &&
        state?.productId &&
        state?.phone &&
        state?.coin &&
        state?.topupType &&
        state?.amount
      ) ||
      isMakingBill ||
      isCountriesLoading ||
      (cryptoPrice && cryptoBalance && cryptoPrice > cryptoBalance),
    [state, isMakingBill, isCountriesLoading, cryptoPrice, cryptoBalance]
  );

  return (
    <Box maxW="500px">
      <Breadcrumb
        my="20px"
        mx="20px"
        separator={<ChevronRightIcon color="gray.500" />}
      >
        <BreadcrumbItem>
          <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink isCurrentPage href="#">
            Airtime
          </BreadcrumbLink>

          {(isUpdatingRate ||
            isCountriesLoading ||
            isWalletsLoading ||
            isPlansLoading) && (
            <CircularProgress
              ml="16px"
              isIndeterminate
              color="green.500"
              size="16px"
            />
          )}
        </BreadcrumbItem>
      </Breadcrumb>

      <Box
        as="form"
        // onSubmit={handleSubmit}
        bg="white"
        p={["24px", "56px"]}
        borderRadius={[0, "16px"]}
        border="1px solid #EFF0F7"
      >
        <VStack>
          <FormControl>
            <Box
              as="label"
              d="inline-block"
              fontSize=".85em"
              fontWeight="400"
              mb="8px"
              color="#4E4B66"
            >
              Country
            </Box>
            <RSelect
              isRtl
              isSearchable={true}
              isLoading={isCountriesLoading}
              value={state?.selectedCountry ?? null}
              onChange={(option) =>
                handleState({
                  country: option.value,
                  selectedCountry: option,
                  countryCode: getCountryCode(option.value),
                  dialCode: getCountryDialCode(option.value),
                  selectValue: null,
                  operatorInfo: null,
                })
              }
              options={countries}
            />
          </FormControl>

          <FormControl mt="20px !important">
            <Box
              as="label"
              d="inline-block"
              fontSize=".85em"
              fontWeight="400"
              mb="8px"
              color="#4E4B66"
            >
              Mobile Operator
            </Box>
            <RSelect
              isSearchable={false}
              isDisabled={!state?.country}
              isLoading={isPlansLoading}
              value={state?.selectValue ?? null}
              onChange={(option) =>
                handleState({
                  operatorId: option.value,
                  operatorInfo: getOperatorInfo(option.value),
                  selectValue: option,
                  topupType: null,
                })
              }
              options={operators}
            />
          </FormControl>

          <FormControl mt="20px !important">
            <Select
              disabled={!state?.operatorId}
              label="Topup Type"
              // isLoading={isCountriesLoading}
              value={state?.topupType ?? ""}
              onChange={(e) =>
                handleState({
                  topupType: e.target.value,
                  amount: null,
                  productInfo: getProductPriceInfo(e.target.value),
                })
              }
              placeholder="Select Topup Type"
            >
              {topupTypes?.map((type, i) => (
                <option key={i} value={toLower(type)}>
                  {capitalize(type)}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl mt="20px !important">
            <Input
              w="100%"
              label="Phone Number"
              disabled={!state?.country}
              value={state?.phone ?? ""}
              startAdornment={state?.dialCode ? `+${state?.dialCode}` : null}
              onChange={(e) => handleState({ phone: e.target.value })}
            />
          </FormControl>

          {state?.phone && (
            <HStack w="100%" alignItems="flex-start">
              <Checkbox
                colorScheme="green"
                onChange={(e) => handleState({ ported: e.target.checked })}
              >
                This number is ported from another network
              </Checkbox>
            </HStack>
          )}

          {state?.topupType === "fixed" && (
            <FormControl mt="20px !important">
              <Select
                isInvalid={
                  cryptoBalance && cryptoPrice && cryptoPrice > cryptoBalance
                }
                disabled={!state?.operatorId}
                label="Amount"
                // isLoading={isCountriesLoading}
                value={`${state.amount}-${state.productId}` ?? ""}
                onChange={(e) => {
                  const [amount, productId] = String(e.target.value).split("-");
                  handleState({ amount, productId });
                }}
                placeholder="Select Fixed Amount"
              >
                {state?.operatorInfo?.products
                  ?.filter((p) => p.priceType === "fixed")
                  ?.map((p, i) => (
                    <option key={i} value={`${p.operatorPrice}-${p.productId}`}>
                      {p.name}
                    </option>
                  ))}
              </Select>

              {state?.coin &&
                cryptoPrice &&
                cryptoBalance &&
                cryptoPrice > cryptoBalance && (
                  <FormHelperText fontSize="xs" color="red.500">
                    Amount exceeds balance in the {toCoinLocale(state?.coin)}{" "}
                    wallet
                  </FormHelperText>
                )}
            </FormControl>
          )}

          {state?.topupType === "range" && (
            <FormControl mt="20px !important">
              <Box
                as="label"
                d="inline-block"
                fontSize=".85em"
                fontWeight="400"
                mb="8px"
                color="#4E4B66"
              >
                Amount
              </Box>
              <NumberInput
                isInvalid={
                  cryptoBalance && cryptoPrice && cryptoPrice > cryptoBalance
                }
                disabled={!state?.operatorId}
                min={+product?.operatorMinPrice ?? 0}
                max={+product?.operatorMaxPrice ?? 0}
                value={state?.amount ?? ""}
                onChange={(e) =>
                  handleState({ amount: e, productId: product.productId })
                }
                endAdornment={
                  state?.operatorInfo?.currency
                    ? state?.operatorInfo?.currency
                    : ""
                }
              />
              {state?.coin &&
                cryptoPrice &&
                cryptoBalance &&
                cryptoPrice > cryptoBalance && (
                  <FormHelperText fontSize="xs" color="red.500">
                    Amount exceeds balance in the {toCoinLocale(state?.coin)}{" "}
                    wallet
                  </FormHelperText>
                )}

              {product && (
                <FormHelperText fontSize="sm">
                  Buy range:{" "}
                  {Number(product?.operatorMinPrice ?? 0).toLocaleString()}{" "}
                  {toUpper(state?.operatorInfo?.currency)} -{" "}
                  {Number(product?.operatorMaxPrice ?? 0).toLocaleString()}{" "}
                  {toUpper(state?.operatorInfo?.currency)}
                </FormHelperText>
              )}
            </FormControl>
          )}

          <FormControl mt="20px !important">
            <Select
              label="Wallet"
              onChange={(e) => handleState({ coin: e.target.value })}
              placeholder="Select coin"
              value={state?.coin ?? ""}
            >
              {/* <option>USDT</option> */}
              {cryptocurrencies
                ?.filter((c) => supportedCoins.includes(toLower(c.coin)))
                ?.map((c, i) => (
                  <option key={i} value={c.coin}>
                    {toCoinLocale(c.coin)}
                  </option>
                ))}
            </Select>
            {cryptoBalance && state?.coin && (
              <FormHelperText fontSize="sm">
                Balance: {toPrecision(cryptoBalance ?? 0, state?.coin, true, 2)}
              </FormHelperText>
            )}
          </FormControl>

          {state?.coin && cryptoPrice && (
            <HStack mt="20px !important" alignSelf="flex-start">
              <Text fontSize="sm" color="#4E4B66">
                Crypto Price:
              </Text>
              <Badge
                fontSize="sm"
                colorScheme={
                  cryptoBalance && cryptoPrice > cryptoBalance ? "red" : "green"
                }
                textTransform="unset"
              >
                {toPrecision(cryptoPrice ?? 0, state?.coin, true, 2)}
              </Badge>
            </HStack>
          )}

          <Button
            disabled={isDisabled}
            fontSize={["sm", "md"]}
            mt="34px !important"
            minW="100%"
            h={["48px", "56px"]}
            p="20px"
            onClick={onOpen}
          >
            Buy Airtime
          </Button>
        </VStack>
      </Box>

      <BillPreview
        title="Preview"
        state={{
          ...state,
          phone: `+${state?.dialCode}${state?.phone?.replace(/^0+/, "")}`,
          prices: { fiat: state?.amount, crypto: cryptoPrice },
        }}
        isOpen={isOpen}
        isLoading={isMakingBill}
        onClose={onClose}
        onConfirm={onPinOpen}
      />

      <SubmitPin
        closeOnSubmit
        isOpen={isPinOpen}
        onClose={onPinClose}
        // onSubmit={(pin) => handleSubmit(pin)}
        onSubmit={(pin) => handleSubmitV2(pin)}
      />

      <SuccessModal
        isOpen={successOpen}
        onClose={handleSuccessModalClose}
        title="Success"
        message="Airtime purchase was successful"
      />
    </Box>
  );
};

export default Airtime;
